// components/providers/AppProviders.jsx
"use client";

import { CookieConsentProvider } from "@/context/CookieConsentContext";

export default function AppProviders({ children }) {
    return <CookieConsentProvider>{children}</CookieConsentProvider>;
}
